import React, { useMemo, useEffect } from 'react'
import { SpinnerField, NumberField } from '@sencha/ext-modern'
import _ from 'lodash'

import { getMixedProps, handleValueChange, useDelayHandleChange } from './blockPublic'
import { useInstData } from 'tyan/public/hooks'

const FormNumber = ({ config: { field, onChange, initValues, /* changedValues,  */defaultStyle, that, that: { state: { _validStamp } } } }) => {
	const { me, setState } = useInstData()

	const { props: { key, ...props } } = getMixedProps(field._fieldType/* '_number' */, [defaultStyle, field])

	!_.isEqual(props, me.props) && (me.props = props)

	// const delayHandleChange = useDelayHandleChange(
	const handleChange = useDelayHandleChange(
		handleValueChange(field.name, initValues[field.name], onChange, 'number')
	)

	// const handleChange = useCallback((f, v, ...rest) => (
	// 	delayHandleChange(f, Math.min(Math.max(v, me.props.minValue || -Infinity), me.props.maxValue || Infinity), ...rest)
	// ), [])

	const Comp = useMemo(() => props.stepValue && SpinnerField || NumberField, [props.stepValue])

	useEffect(() => {
		_validStamp && me.cmp?.validate()
	}, [_validStamp])

	return <Comp {...me.props} ref={ref => ref && (me.cmp = ref.cmp)}
		onChange={handleChange}
		onErrorChange={(field, error) => that.setState(state => ({ formErrorCount: (state.formErrorCount || 0) + (error ? 1 : -1) }))}
	/>
}


const renderNumber = config => {
	const { key } = config.field || {}
	return <FormNumber key={key} config={config} />
}

export default renderNumber